import styled from 'styled-components';

export const NoResults = styled.div`
  display: flex;
  justify-content: center;
  padding: 200px 0px;
`;
